import { gql } from '@apollo/client';
const GET_MENTION_NOTIFICATIONS = gql `
  query getMyMentionNotifications($page: Int!, $size: Int!) {
    getMyMentionNotifications(page: $page, size: $size) {
      content {
        id
        message
        status
        isRead
        createdDate
        author {
          id
          username
          email
          avatar
        }
        conversation {
          id
          title
          pageUrl
        }
      }
      totalElements
      totalPages
      number
      size
    }
  }
`;
export default GET_MENTION_NOTIFICATIONS;
